/* cisco_advisory.icon.svg.js */

module.exports = {
    icon: `
        <svg viewBox="0 0 22 20" preserveAspectRatio="none">
        <path class="foreground-gl" d="M19,.46H3.55A2.16,2.16,0,0,0,1.39,2.62v15.1A2.25,2.25,0,0,0,3.64,20H18.81a2.45,2.45,0,0,0,2.44-2.44V2.73A2.26,2.26,0,0,0,19,.46ZM13.13,15.59a1.73,1.73,0,0,1-1.72,1.51,1.73,1.73,0,0,1-1.87-1.49h-4c-.77-.08-1.1-.48-.87-1.14A1.39,1.39,0,0,1,5,13.8a4,4,0,0,0,1.54-2.41c.16-.68.28-1.36.38-2.05a5.22,5.22,0,0,1,.87-2.46A3.81,3.81,0,0,1,10,5.49l.2-.06,0,0a1.24,1.24,0,0,1-.37-1.26,1.34,1.34,0,0,1,.58-.73,1.69,1.69,0,0,1,1.92.09c.6.47.63,1.13.09,1.9.26.09.53.16.79.26a3.62,3.62,0,0,1,2.22,2.46,9.7,9.7,0,0,1,.29,1.61,9.38,9.38,0,0,0,.74,2.73,3.36,3.36,0,0,0,1.05,1.24,1.26,1.26,0,0,1,.55,1.21.73.73,0,0,1-.71.64l-.57,0H13.13Z"/>
        </svg>
    `
};
